/*!
 *  (c)(r) 2008-2021 IT-Service Robert Frunzke
 */

import { get_array_of_strings_from_ml_text, str_trim } from './util.js';
import { jQuery } from '../other/jquery-hooked.js';
import { mjt } from './i18ntexts.js';

import { MDLocale } from './locale-impl.js';

import { MDMeta } from './meta-data.js';


/**
 * Manja Metadata Filter Widgets ( .mjMetaFilterWidget )
 *
 * common widget options:
 *  - meta_id	: int
 *  - meta_type	: int (enum MetaType, MT_*)
 *  - type		: mj_mfw_type
 *  - change	: function( value )
 *  - init_done	: function( )
 *  - config	: type-specific configuration
 *
 * types:
 *  - string				single-line text
 *  	html:				input type=text
 *  	config:
 *  		+ op			for meta_type string: e, m, ne, z; for meta_type int or real: e, ne, g, ge, l, le, z
 *
 *  - list					list of values
 *  	html:				select or radio buttons
 *  	config:
 *  		+ values		[ [value,label], [value,label], ... ]
 *  						- where value is a list of op+cmp_value tuples: [[op,v],[op,v],...]
 *
 *  - val_list				like list, but with a simplified configuration
 *  	html:				select
 *  	config:
 *  		+ values		string
 *  						- where each line represents a single value
 *  						- the values will be submitted as an "eq" operation
 *
 *  - auto_list				like list, but available values will be determined automatically from available content
 *  - auto2_list			like list, but available values will be determined from metadata field configuration (vl_defaults & vl_translations)
 *
 *  - set					multiple choice
 *  	html:				list of checkboxes
 *  	config:
 *  		+ op			eo (equal to one of), mo (match one of)
 *  		+ values		[ [value,label], [value,label], ... ]
 *
 *  - val_set				liste set, but with a simplified configuration
 *  	html:				list of checkboxes
 *  	config:
 *  		+ op			eo (equal to one of), mo (match one of)
 *  		+ values		string
 *  						- where each line represents a single value
 *
 *  - auto_set				like set, but available values will be determined automatically from available content
 *  - auto2_set				like set, but available values will be determined from metadata field configuration (vl_defaults & vl_translations)
 *  - auto3_set				like set, but available values are not proposed as a list, but are available as tags (after typing first few letter)
 *
 *  - date					date
 *  	html:				jquery ui datepicker
 *  	config:
 *  		+ op			e, ne, g, ge, l, le, z
 *
 *  - date_range			date range
 *  	html:				two jquery ui datepickers
 *  	config:
 *  		-none-
 *
 * methods:
 *  - init(opts)
 *  - get()			: return current filter value
 *  - set(val)		: set new filter value
 *  - empty()		: return whether value is empty/unset/inactive
 *  - reset()		: reset to an empty value
 *  - format(value)	: return formatted value (html for display)
 *  - options()		: return options that were used on init()
 *  - config()		: alias for options()
 *
 * usage:
 *  $('#container').mjMetaFilterWidget( {...} )
 *  var is_empty = $('#container').mjMetaFilterWidget('empty');
 *  $('#container').mjMetaFilterWidget('reset')
 *
 */
(function($) {

	var simple_meta_filter_widgets_default_methods = {
		get: function( opts ) {
			if( opts.init_in_progress ) return null;
			return $(this).mjWidget('get');
		},
		set: function( opts, val ) {
			if( opts.init_in_progress ) return;
			return $(this).mjWidget('set',val);
		},
		empty: function( opts ) {
			if( opts.init_in_progress ) return true;
			var r0 = $(this).mjWidget('get');
			if( Array.isArray(r0) ) return r0.length===0;
			return r0===null || r0==='';
		},
		reset: function( opts ) {
			if( opts.init_in_progress ) return;
			$(this).mjWidget('set','');
		},
		format: function( opts, val ) {
			return val;
		},
		is_init_in_progress: function( opts ) {
			return opts.init_in_progress || false;
		},
	};

	var meta_filter_widgets = {
		'string': Object.assign( {}, simple_meta_filter_widgets_default_methods, {
			init: function( opts ) {
				$(this).mjWidget( {
					type: 'string',
					name: 'search[flt:'+opts.meta_id+':'+opts.config.op+']',
					change: opts.change,
				} );
			},
		} ),
		'list': Object.assign( {}, simple_meta_filter_widgets_default_methods, {
			init: function( opts ) {
				// first entry is an empty item
				var nv = [ ['',''] ],
					// json stringify values (for inclusion into <option value=".."> tags)
					vl = opts.config.values.length,
					v;
				for( var i=0; i<vl; ++i ) {
					v = opts.config.values[i];
					nv.push( [ JSON.stringify(v[0]), v[1] ] );
				}
				var mjw_opts = {
					type: 'list',
					name: 'search[flt:'+opts.meta_id+']' + ( opts.multiple ? '[]' : '' ),
					change: opts.change,
					values: nv,
					value: opts.hasOwnProperty('value') ? opts.value : '',
				};
				if( opts.multiple ) mjw_opts.multiple = true;
				if( opts.dropdownParent ) mjw_opts.dropdownParent = opts.dropdownParent;
				$(this).mjWidget( mjw_opts );
			},
			format: function( opts, val ) {
				var vl = opts.config.values.length;
				for( var i=0; i<vl; ++i ) {
					var v = opts.config.values[i],
						vk = Array.isArray(v[0]) ? JSON.stringify(v[0]) : v[0];
					if( val==vk ) return v[1];
				}
				return null;
			},
		} ),
		'set': Object.assign( {}, simple_meta_filter_widgets_default_methods, {
			init: function( opts ) {
				$(this).mjWidget( {
					type: 'set',
					name: 'search[flt:'+opts.meta_id+':'+opts.config.op+']',
					change: opts.change,
					values: opts.config.values,
				} );
			},
			reset: function( opts ) {
				if( opts.init_in_progress ) return;
				$(this).mjWidget('set',[]);
			},
			format: function( opts, val ) {
				var vls = Array.isArray(val) ? val : [val],
					//superfluous!://opts = $(this).data('mj-mfw-opts'),
					vl = opts.config.values.length,
					nvls = vls.map( function( val, val_idx ) {
						for( var i=0; i<vl; ++i ) {
							var v = opts.config.values[i];
							if( val==v[0] ) return v[1];
						}
						return val;
					} );
				return nvls.join(' '+mjt('search-info-or')+' ');
			},
		} ),
		'date': Object.assign( {}, simple_meta_filter_widgets_default_methods, {
			init: function( opts ) {
				$(this).mjWidget( {
					type: 'date',
					name: 'search[flt:'+opts.meta_id+':'+opts.config.op+']',
					change: opts.change,
				} );
			},
			format: function( opts, val ) {
				return MDLocale.fmt_date(val);
			},
		} ),
		'date_range': {
			init: function( opts ) {
				var onchange = null;
				if( typeof opts.change === 'function' ) {
					var self = this;
					onchange = function() {
						opts.change.call(self);
					};
				}
				var from = $( '<span/>', { 'class':'col-2' } )
					.mjWidget( {
						type: 'date',
						name: 'search[flt:'+opts.meta_id+':ge]',
						change: onchange,
					} );
				var to = $( '<span/>', { 'class':'col-2' } )
					.mjWidget( {
						type: 'date',
						name: 'search[flt:'+opts.meta_id+':le]',
						change: onchange,
					} );
				$( '<label/>', { 'class':'col-1', 'for':from.mjWidget('id') } )
					.text(mjt('search-options-datetime-from','!'))
					.appendTo(this)
				;
				from.appendTo(this);
				$( '<label/>', { 'class':'col-1', 'for':to.mjWidget('id') } )
					.text(mjt('search-options-datetime-to','!'))
					.appendTo(this)
				;
				to.appendTo(this);
			},
			get: function( opts ) {
				if( opts.init_in_progress ) return null;
				var wdg_elems = $(this).children('span.col-2');
				return {	from: wdg_elems.eq(0).mjWidget('get'),
					to:   wdg_elems.eq(1).mjWidget('get')  };
			},
			set: function( opts, value ) {
				if( opts.init_in_progress ) return;
				var wdg_elems = $(this).children('span.col-2');
				wdg_elems.eq(0).mjWidget( 'set', value.hasOwnProperty('from') && value.from ? value.from : '' );
				wdg_elems.eq(1).mjWidget( 'set', value.hasOwnProperty('to') && value.to ? value.to : '' );
			},
			empty: function( opts ) {
				if( opts.init_in_progress ) return;
				var wdg_elems = $(this).children('span.col-2');
				return wdg_elems.eq(0).mjWidget('get')=='' && wdg_elems.eq(1).mjWidget('get')=='';
			},
			reset: function( opts ) {
				if( opts.init_in_progress ) return;
				$(this).children('span.col-2').mjWidget('set','');
			},
			format: function( opts, val ) {
				var r = '';
				if( val.hasOwnProperty('from') && val.from!='' ) r += mjt('search-info-datetime-from')+' '+MDLocale.fmt_date(val.from);
				if( val.hasOwnProperty('to') && val.to!='' ) r = str_trim(r+' '+mjt('search-info-datetime-to')+' '+MDLocale.fmt_date(val.to));
				return r;
			},
			is_init_in_progress: function( opts ) {
				return false;
			},
		},
	};

	meta_filter_widgets.val_list = Object.assign( {}, meta_filter_widgets.list, {
		init: function( opts ) {
			var self = this,
				$self = $(this),
				values = [],
				xvals = opts.config.values.split('\n');
			for( var i=0; i<xvals.length; ++i ) {
				var val = xvals[i];
				if( str_trim(val)!='' ) values.push( [ [ ['e',val] ], val ] );
			}
			var new_opts = Object.assign( {}, opts, { config:{values:values} } );
			meta_filter_widgets.list.init.call(self,new_opts);
			$self.data('mj-mfw-opts',new_opts);
		},
	} );
	meta_filter_widgets.auto_list = Object.assign( {}, meta_filter_widgets.list, {
		init: function( opts ) {
			var self = this,
				$self = $(this);
			opts.init_in_progress = true;
			$.postJSON( 'json/widgets/meta-values_list', 'meta_id='+encodeURIComponent(opts.meta_id), function _mfw_auto_list_init_response(j) {
				var values = [];
				if( j.values ) {
					var len = j.values.length;
					for( var i=0; i<len; ++i ) {
						var val = j.values[i],
							lbl = MDMeta.getDisplayDataItem(val,opts.meta_id,true);
						values.push( [ [ ['e',val] ], lbl ] );
					}
				}
				var new_opts = Object.assign( {}, opts, { config:{values:values} } );
				meta_filter_widgets.list.init.call(self,new_opts);
				delete new_opts.init_in_progress;
				$self.data('mj-mfw-opts',new_opts);
				new_opts._call_init_done();
			} );
		},
	} );
	meta_filter_widgets.auto2_list = Object.assign( {}, meta_filter_widgets.list, {
		init: function( opts ) {
			var self = this,
				$self = $(this);
			opts.init_in_progress = true;
			MDMeta.queryDefinition( opts.meta_id, function(md) {
				var vld = md.hasOwnProperty('options') && md.options.hasOwnProperty('vl_defaults') ? get_array_of_strings_from_ml_text(md.options.vl_defaults) : [],
					values = [];
				// with and without translations...
				for( var i=0; i<vld.length; ++i ) {
					var val = vld[i],
						lbl = MDMeta.getDisplayDataItem(val,opts.meta_id,true);
					values.push( [ [ ['e',val] ], lbl ] );
				}
				var new_opts = Object.assign( {}, opts, { config:{values:values} } );
				meta_filter_widgets.list.init.call(self,new_opts);
				delete new_opts.init_in_progress;
				$self.data('mj-mfw-opts',new_opts);
				new_opts._call_init_done();
			} );
		},
	} );
	meta_filter_widgets.val_set = Object.assign( {}, meta_filter_widgets.set, {
		init: function( opts ) {
			var self = this,
				$self = $(this),
				values = [],
				xvals = opts.config.values.split('\n')
				;
			for( var i=0; i<xvals.length; ++i ) {
				var val = xvals[i];
				if( str_trim(val)!='' ) values.push( [val,val] );
			}
			var new_opts = Object.assign( {}, opts, { config:{op:opts.config.op||'eo',values:values} } );
			meta_filter_widgets.set.init.call(self,new_opts);
			$self.data('mj-mfw-opts',new_opts);
		},
	} );
	meta_filter_widgets.auto_set = Object.assign( {}, meta_filter_widgets.set, {
		init: function( opts ) {
			var self = this,
				$self = $(this);
			opts.init_in_progress = true;
			$.postJSON( 'json/widgets/meta-values_list', 'meta_id='+encodeURIComponent(opts.meta_id), function(j) {
				var values = [];
				if( j.values ) {
					var len = j.values.length;
					for( var i=0; i<len; ++i ) {
						var val = j.values[i],
							lbl = MDMeta.getDisplayDataItem(val,opts.meta_id,true);
						values.push( [val,lbl] );
					}
				}
				var new_opts = Object.assign( {}, opts, { config:{op:'eo',values:values} } );
				meta_filter_widgets.set.init.call(self,new_opts);
				delete new_opts.init_in_progress;
				$self.data('mj-mfw-opts',new_opts);
				new_opts._call_init_done();
			} );
		},
	} );
	meta_filter_widgets.auto2_set = Object.assign( {}, meta_filter_widgets.set, {
		init: function( opts ) {
			var self = this,
				$self = $(this);
			opts.init_in_progress = true;
			MDMeta.queryDefinition( opts.meta_id, function(md) {
				var vld = md.hasOwnProperty('options') && md.options.hasOwnProperty('vl_defaults') ? get_array_of_strings_from_ml_text(md.options.vl_defaults) : [],
					values = [];
				// with and without translations...
				for( var i=0; i<vld.length; ++i ) {
					var val = vld[i],
						lbl = MDMeta.getDisplayDataItem(val,opts.meta_id,true);
					values.push( [ val, lbl ] );
				}
				var new_opts = Object.assign( {}, opts, { config:{op:'eo',values:values} } );
				meta_filter_widgets.set.init.call(self,new_opts);
				delete new_opts.init_in_progress;
				$self.data('mj-mfw-opts',new_opts);
				new_opts._call_init_done();
			} );
		},
	} );
	meta_filter_widgets.auto3_set = Object.assign( {}, meta_filter_widgets.list, {
		init: function( opts ) {
			var self = this,
				$self = $(this);
			opts.init_in_progress = true;
			$.postJSON( 'json/widgets/meta-values_list', 'meta_id='+encodeURIComponent(opts.meta_id), function _mfw_auto3_set_init_response(j) {
				var values = [];
				if( j.values ) {
					var len = j.values.length;
					for( var i=0; i<len; ++i ) {
						var val = j.values[i],
							lbl = MDMeta.getDisplayDataItem(val,opts.meta_id,true);
						values.push( [ [ ['e',val] ], lbl ] );
					}
				}
				var new_opts = Object.assign( {}, opts, { config:{values:values}, multiple:true, ignore_case:true } );
				meta_filter_widgets.list.init.call(self,new_opts);
				delete new_opts.init_in_progress;
				$self.data('mj-mfw-opts',new_opts);
				new_opts._call_init_done();
			} );
		},
		format: function( opts, val ) {
			var vls = Array.isArray(val) ? val : [val],
				//superfluous!://opts = $(this).data('mj-mfw-opts'),
				vl = opts.config.values.length,
				nvls = vls.map( function( xval, val_idx ) {
					if( typeof xval === 'string' && xval.length>2 && xval[0]=='[' && xval[1]=='[' ) xval = JSON.parse(xval);
					if( Array.isArray(xval) && xval.length>=1 ) xval = xval[0];
					if( Array.isArray(xval) && xval.length>1 ) xval = xval[1];
					for( var i=0; i<vl; ++i ) {
						var v = opts.config.values[i];
						if( xval==v[0] ) return v[1];
					}
					return xval;
				} );
			return nvls.join(' '+mjt('search-info-or')+' ');
		},
	} );

	function _define_meta_filter_widget_methods( self, opts ) {
		//superfluous://if( opts._widget_methods ) throw new Error('mjMetaFilterWidget of type "'+opts.type+'" has its widget methods already assigned';
		if( !meta_filter_widgets[opts.type] ) throw new Error('Unknown mjMetaFilterWidget type "'+opts.type+'" (while initializing it)');
		opts._widget_methods = meta_filter_widgets[opts.type];
	}

	function _call_meta_filter_widget_method2( self, opts, func, args ) {
		if( !opts._widget_methods ) throw new Error('mjMetaFilterWidget of type "'+opts.type+'" is not quite initialized (while trying to call function "'+func+'" on it)');
		if( !opts._widget_methods[func] ) throw new Error('mjMetaFilterWidget type "'+opts.type+'" has no function "'+func+'"');
		return opts._widget_methods[func].apply(self,args);
	}

	var methods = {
		init: function( opts ) {
			if( !opts.type ) throw new Error('No mjMetaFilterWidget type specified');
			_define_meta_filter_widget_methods(this,opts);
			var self = $(this);
			self.data('mj-mfw-opts',opts);

			opts._defered_init_tv = null;
			opts._call_init_done = function _call_init_done() {
				this._cancel_init_done();
				if( this.init_done ) this.init_done();
			};
			opts._cancel_init_done = function _cancel_init_done() {
				if( this._defered_init_tv !== null ) {
					clearTimeout(this._defered_init_tv);
					this._defered_init_tv = null;
				}
			};

			_call_meta_filter_widget_method2(this,opts,'init',arguments);

			var new_opts = self.data('mj-mfw-opts');
			if( new_opts.init_done ) {
				var _defered_init_done = function() {
					new_opts._defered_init_tv = null;
					if( new_opts._widget_methods.is_init_in_progress.call(this,new_opts) ) new_opts._defered_init_tv = setTimeout(_defered_init_done,250);
					else new_opts._call_init_done();
				};
				_defered_init_done();
			}
		},
		destroy: function( opts ) {
			if( opts && opts._cancel_init_done ) opts._cancel_init_done();
			$(this).empty().removeData('mj-mfw-opts');
		},
		options: function( opts ) {
			return opts;
		},
		config: function( opts ) {
			return opts;
		},
		get: 'pass',
		set: 'pass',
		empty: 'pass',
		reset: 'pass',
		format: 'pass',
		is_init_in_progress: 'pass',
	};

	$.fn.mjMetaFilterWidget = function mjMetaFilterWidget( arg ) {
		// -> "this" is a jQuery object
		var args=arguments, rv=null;
		if( typeof arg === 'object' || !arg ) {
			this.each( function mjMetaFilterWidget1_init() {
				// -> "this" is a DOMElement
				methods.init.apply(this,args);
			} );
			return this;
		} else if( methods[arg] ) {
			var method = methods[arg];
			var item_args = Array.prototype.slice.call(args);
			this.each( function mjMetaFilterWidget1_other() {
				// -> "this" is a DOMElement
				item_args[0] = $(this).data('mj-mfw-opts');
				if( item_args[0]===undefined && arg!=='destroy' ) throw new Error('Element was not (yet) initialized as an mjMetaFilterWidget');
				rv = ( method==='pass' ? item_args[0]._widget_methods[arg] : method ).apply(this,item_args);
			} );
			return rv===null ? this : rv;
		}
		throw new Error('Method '+arg+' does not exist on jQuery.mjMetaFilterWidget');
	};
})(jQuery);
